"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _trim = _interopRequireDefault(require("lodash/trim"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _box = _interopRequireDefault(require("../box"));
var _count = _interopRequireDefault(require("../poly/count"));
var _reactMap = _interopRequireDefault(require("../poly/reactMap"));
const _excluded = ["children", "className", "isSubSection", "itemMargins"];
const useClasses = (0, _styles.makeStyles)(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    width: '100%'
  },
  defaultItem: {
    marginTop: 0,
    marginBottom: 0
  },
  item: ({
    itemMargins
  }) => ({
    marginTop: 0,
    marginBottom: itemMargins.mobile || '30px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: itemMargins.tablet || '30px'
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: itemMargins.desktop || '50px'
    }
  }),
  subSection: {
    padding: 0,
    [theme.breakpoints.up('md')]: {
      padding: 0
    }
  }
}), {
  classNamePrefix: 'TCUISection'
});
const Section = _ref => {
  let {
      children,
      className,
      isSubSection,
      itemMargins
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses({
    itemMargins
  });
  return /*#__PURE__*/_react.default.createElement(_box.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(_classes.root, {
      [_classes.subSection]: isSubSection
    }, className)
  }), (0, _reactMap.default)((child, i, flattenedChildren) => {
    if (!(0, _isString.default)(child)) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        className: (0, _clsx.default)(_classes.defaultItem, {
          [_classes.item]: i + 1 !== _react.default.Children.count(flattenedChildren),
          [_classes.subSection]: child.type === Section
        }, child.props.className)
      });
    }
    if ((0, _count.default)((0, _trim.default)(child)) > 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx.default)({
          [_classes.item]: i + 1 !== _react.default.Children.count(flattenedChildren)
        })
      }, child);
    }
    return null;
  }, children));
};
Section.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  isSubSection: _propTypes.default.bool,
  itemMargins: _propTypes.default.shape({
    mobile: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    tablet: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    desktop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })
};
Section.defaultProps = {
  children: null,
  className: null,
  isSubSection: false,
  itemMargins: {
    mobile: '30px',
    tablet: '30px',
    desktop: '50px'
  }
};
var _default = exports.default = Section;